import { createFetch } from '@vueuse/core';

export function useMoriaFetch() {
  const config = useRuntimeConfig()

  return createFetch({
    baseUrl: config.public.apiUrl,
    options: {
     beforeFetch({ options }) {
        options.headers = {
          ...options.headers,
          'Content-Type': 'application/json',
        }

        options.credentials = 'include'

        return { options }
      }
    }
  })
}
